(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Attendant', Attendant);

    Attendant.$inject = ['$resource'];

    function Attendant ($resource) {
        var resourceUrl =  'api/attendants/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
